import './AddIntegrationPopup.css';
import React, { useEffect, useState } from 'react';
import Button from '../../Button/Button';
import { useNotification } from 'src/hooks/useNotification';
import AddButtonIcon from '../../../assets/img/add-button-icon.svg';
import { useLoader } from 'src/provider/LoaderProvider';
import { baseApi, useAddIntegrationMutation } from 'src/services';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { AddIntegrationList } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationList';
import { AddIntegrationSettings } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';
import { useAppSelector } from 'src/store';

export const AddIntegrationPopup = ({ project, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const notification = useNotification();
  const dispatch = useDispatch();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const { id } = useParams();
  const [
    addIntegration,
    {
      data: addIntegrationRes,
      isError: isErrorAddIntegration,
      isLoading: isLoadingAddIntegration,
      isSuccess: isSuccessAddIntegration,
    },
  ] = useAddIntegrationMutation() as any;
  const loader = useLoader();

  const setIntegration = (data) => {
    dispatch(setSelectedIntegration(data ? { ...selectedIntegration, ...data } : null));
  };

  // `skip` means the form already created the integration (e.g. via "Connect with Zendesk").
  const createIntegration = (data, skip = false) => {
    if (skip) {
      dispatch(baseApi.util.invalidateTags(['ProjectById']));
      return onOpenChange(false);
    }

    addIntegration({ id, body: data });
  };

  useEffect(() => {
    if (isSuccessAddIntegration) {
      notification.success(`Integration ${addIntegrationRes.integration_type} was added.`);
      loader.hide();
      onOpenChange(false);
      dispatch(baseApi.util.invalidateTags(['ProjectById']));
    }
  }, [isSuccessAddIntegration]);

  useEffect(() => {
    if (isLoadingAddIntegration) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingAddIntegration]);

  useEffect(() => {
    if (isErrorAddIntegration) {
      loader.hide();
    }
  }, [isErrorAddIntegration]);

  const onOpenChange = (isOpen) => {
    setOpen(isOpen);
    !isOpen && setIntegration(null);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogTrigger
          disabled={disabled}
          asChild
          className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
        >
          <Button className="transparent">
            <span>Add integration</span>
            <img src={AddButtonIcon} />
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {selectedIntegration ? 'Integration Settings' : 'Integrations'}
            </DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            {selectedIntegration ? (
              <AddIntegrationSettings
                onSubmit={createIntegration}
                onBackButton={() => setIntegration(null)}
              />
            ) : (
              <AddIntegrationList project={project} onClick={(data) => setIntegration(data)} />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
